<template>
  <div class="style-grid-container">
    <DuplicateStyle
      :showPopup="showPopup"
      @visibleDialog="visibleDialog"
      :duplicateStyleId="duplicateStyleId"
      @duplicateId="getDuplicateId"
    ></DuplicateStyle>

    <div v-show="styleloadingGrid || loadingGrid">
      <GridLoading></GridLoading>
    </div>
    <div v-show="!(styleloadingGrid || loadingGrid)" class="grid-wrapper">
      <kendo-grid
        ref="detailsGrid"
        :data-source="gridDataSource"
        :columns="columns"
        :sortable="true"
        :column-menu="true"
        :filterable="true"
        :groupable="{ messages: { empty: groupTitle } }"
        :reorderable="true"
        :selectable="true"
        :selected-field="selectedField"
      >
      </kendo-grid>
    </div>
    <div class="pagination-footer">
      <BPagination
        v-model="currentPage"
        :total-rows="perPages"
        :per-page="25"
        @page-click="onPaginationChange"
        size="sm"
      ></BPagination>
      <BModalOrchestrator></BModalOrchestrator>
    </div>
  </div>
</template>
<script lang="ts">
import { Grid } from "@progress/kendo-grid-vue-wrapper";
import { ReportApi, StyleApi, DataImportApi, UserAdminSettingApi } from "@/api";
import { Spreadsheet, SpreadsheetSheet } from "@progress/kendo-spreadsheet-vue-wrapper";
import { Window } from "@progress/kendo-window-vue-wrapper";
import GridLoading from "./GridLoading.vue";
import styleCreateComp from "./StyleCreateComp.vue";
import DuplicateStyle from "./DuplicateStylePopup.vue";
import { jsPDF } from "jspdf";
import { autoTable } from "jspdf-autotable";
import ArialUnicodeMS from "../../../../public/ArialUnicodeMS.ttf";
import { defineComponent } from "vue";
import { useToast } from "vue-toastification";
import { BvEvent, BPagination, useModalController, BModalOrchestrator } from "bootstrap-vue-next";
import plausible from "@/core/plausible";
import "../../../../public/arial-unicode-ms-bold-bold.js";

export default defineComponent({
  name: "StyleGrid",
  components: {
    BPagination,
    "kendo-grid": Grid,
    window: Window,
    spreadsheet: Spreadsheet,
    "spreadsheet-sheet": SpreadsheetSheet,
    GridLoading,
    styleCreateComp,
    DuplicateStyle,
    BModalOrchestrator
  },
  props: {
    stylesData: null as any,
    perPages: null as any,
    loadingGrid: {
      type: Boolean,
      default: false
    },
    totalStylesCount: {
      type: Number,
      default: 0
    }
  },
  emits: ["updatePages", "changeFilteredDataHandler", "editStyleId", "duplicateEditId", "changeDataHandler"],
  setup() {
    const reportApi = new ReportApi()!;
    const dataImportApi = new DataImportApi()!;
    const styleApi = new StyleApi()!;
    const userAdminSettingApi = new UserAdminSettingApi()!;
    const { confirm } = useModalController();
    const confirmModal = (confrim: any, modalcontent: any): Promise<any> | any => {
      return confirm?.({
        props: {
          title: confrim,
          contentClass: modalcontent,
          body: modalcontent,
          size: "md",
          okTitle: "OK",
          cancelTitle: "Cancel",
          centered: true,
          okVariant: "danger"
        }
      });
    };

    return {
      reportApi,
      dataImportApi,
      styleApi,
      userAdminSettingApi,
      confirm,
      confirmModal
    };
  },
  data() {
    const edit = this.$t("styleGrid.edit") as any;
    const clone = this.$t("styleGrid.colne") as any;
    const garmentReport = this.$t("styleGrid.singleGarmentReport") as any;
    const threadReport = this.$t("styleGrid.threadUsageReport") as any;
    const deleteStylerow = this.$t("styleGrid.delete") as any;
    return {
      toast: useToast(),
      ConfigurationString: "",
      calculationEngineType: "",
      selectedField: "selected" as any,
      singleGarment: null as any,
      threadUsage: null as any,
      jsondataExcelSheet: null as any,
      errorCell: [] as any,
      show: false,
      currentPage: 1,
      windowPopupTitle: "" as any,
      duplicateSaveButton: false,
      download: this.$t("styleGrid.downloaded") as any,
      featureAvailAllUpload: this.$t("styleGrid.featureIsAvailableToAllUploads") as any,
      successMsg: this.$t("styleGrid.dataSavedSuccesfully") as any,
      success: this.$t("styleGrid.success") as any,
      errorMsg: this.$t("styleGrid.thereAreSomeErrors") as any,
      error: this.$t("styleGrid.error") as any,
      deletedTitle: this.$t("styleGrid.deleted") as any,
      note: this.$t("styleGrid.note") as any,
      areYouSureYouWantToDeleteStyle: this.$t("styleGrid.areYouSureYouWantToDelete") as any,
      confrim: this.$t("styleGrid.pleaseConfirm") as any,
      groupTitle: this.$t("styleGrid.dragAColumnHeader") as any,
      incompleteData: this.$t("styleGrid.incompleteData") as any,
      seamLengthUnit: "" as any,
      tktTexValue: "" as any,
      defaultAllowanceVal: "" as any,
      isImperial: false,
      bightConversionFactor: 1,
      seamLengthConversionFactor: 1,
      stich3cmConversionFactor: 1,
      visible: false,
      showPopup: false,
      duplicateStyleId: 0,
      showAlert: false,
      pageWidth: 0,
      totalPages: 1,
      fontUrl: null as any,
      lang: null as any,
      customFont: "helvetica",
      columnSpreadsSheet: [
        {
          width: 100
        },
        {
          width: 155
        },
        {
          width: 120
        },
        {
          width: 100
        },
        {
          width: 150
        },
        {
          width: 150
        },
        {
          width: 100
        },
        {
          width: 100
        },
        {
          width: 150
        },
        {
          width: 150
        },
        {
          width: 150
        },
        {
          width: 100
        },
        {
          width: 100
        },
        {
          width: 100
        },
        {
          width: 160
        },
        {
          width: 100
        },
        {
          width: 100
        }
      ],
      columns: [
        { field: "name", title: this.$t("styleGrid.style"), width: "150px" },
        { field: "id", title: this.$t("styleGrid.styleId"), width: "150px", hidden: true },
        { field: "description", title: this.$t("styleGrid.description"), format: "{0:c}", width: "120px" },
        { field: "customer", title: this.$t("styleGrid.customer"), width: "120px" },
        { field: "productCategory", title: this.$t("styleGrid.productCategory"), width: "130px" },
        { field: "productType", title: this.$t("styleGrid.product"), width: "120px" },
        { field: "weightType", title: this.$t("styleGrid.fabricWeight"), width: "120px" },
        { field: "customSettingName", title: this.$t("styleGrid.settingName"), width: "120px" },
        {
          field: "totalLengthOrSGC",
          title: "SGC",
          width: "120px",
          template:
            "#if(totalLengthOrSGC === '' ||totalLengthOrSGC==null ){# <span title='Print report to view this value'>-</span> #}else{# #=totalLengthOrSGC#  #}#"
        },
        { field: "createdBy", title: this.$t("styleGrid.createdBy"), width: "120px" },
        {
          field: "creationTime",
          title: this.$t("styleGrid.createdDate"),
          type: "date",
          format: "{0:dd-MMM-yyyy}",
          width: "130px"
        },
        { field: "editedBy", title: this.$t("styleGrid.editedBy"), width: "120px" },
        {
          field: "id",
          command: [
            {
              template: `<a role=button class='k-button k-button-icontext k-grid-editStyle' style="border-radius: 3px;
                        border-style: none;"><span class="fas fa-edit"  title="${edit}"></span></a>`,
              name: "editStyle",
              text: "",
              click: this.editStyle
            },
            {
              template: `<a role=button class='k-button k-button-icontext k-grid-duplicateStyle' style="border-radius: 3px;
                        border-style: none;"><span class="far fa-clone" title="${clone}"></span></a>`,
              name: "duplicateStyle",
              text: " ",
              click: this.duplicateStyle
            },
            {
              template: `<a role=button class='k-button k-button-icontext k-grid-singleGarment' style="border-radius: 3px;
                        border-style: none;"><span class="far fa-file" title="${garmentReport}"></span></a>`,
              name: "singleGarment",
              text: " ",
              click: this.downloadSingleGarmentReport
            },
            {
              template: `<a role=button class='k-button k-button-icontext k-grid-threadUsage' style="border-radius: 3px;
                        border-style: none;"><span class="far fa-copy" title="${threadReport}"></span></a>`,
              name: "threadUsage",
              text: " ",
              click: this.downloadThreadGarmentReport
            },
            {
              template: `<a role=button class='k-button k-button-icontext k-grid-deleteStyle' style="border-radius: 3px;
                        border-style: none;"><span class='fa fa-trash' title="${deleteStylerow}"></span></a>`,
              name: "deleteStyle",
              text: " ",
              click: this.deleteStyle
            }
          ],
          title: this.$t("styleGrid.actions"),
          width: "220px"
        }
      ],
      styleloadingGrid: null as any,
      isFilterApplied: false,
      filtersArray: [] as any,
      allFilters: [] as any,
      fontStyleForPDF: "" as any
    };
  },
  async mounted() {
    await this.getCalculationEngineType().catch(() => undefined);
    this.styleloadingGrid = this.loadingGrid;
    const grid = (this.$refs["detailsGrid"] as any).kendoWidget();
    grid.bind("filter", (e: any) => {
      const currentFilters = e.filter;
      if (currentFilters && currentFilters.filters && currentFilters.filters.length > 0) {
        this.isFilterApplied = true;
        const fieldsToReplace = new Set(currentFilters.filters.map((f: any) => f.field));

        this.filtersArray = this.filtersArray.filter((f: any) => !fieldsToReplace.has(f.field));

        this.allFilters = this.allFilters.filter(
          (group: any) => !group.filters.some((f: any) => fieldsToReplace.has(f.field))
        );
        this.allFilters.push(currentFilters);
        for (let filter of currentFilters.filters) {
          if (filter.field == "creationTime" && filter.value != "" && filter.value != null) {
            const utcConvertedDate = new Date(
              Date.UTC(filter.value.getFullYear(), filter.value.getMonth(), filter.value.getDate())
            );
            filter.value = utcConvertedDate.toISOString();
          }
          const filterWithLogic = { ...filter, logic: currentFilters.logic };
          this.filtersArray.push(filterWithLogic);
        }
        this.getFilteredData(this.filtersArray, "CreationTime", 0, 25);
      } else {
        this.allFilters = this.allFilters.filter(
          (group: any) => !group.filters.some((f: any) => e.field.includes(f.field))
        );
        this.filtersArray = this.filtersArray.filter((f: any) => !e.field.includes(f.field));
        if (this.filtersArray.length > 0) {
          this.getFilteredData(this.filtersArray, "CreationTime", 0, 25);
        }
        if (this.allFilters.length == 0) {
          this.styleloadingGrid = true;
          grid.dataSource.transport.data = this.stylesData;
          grid.dataSource.data(this.stylesData);
          grid.dataSource.read();
          this.$emit("updatePages", this.totalStylesCount);
          this.currentPage = 1;
          this.isFilterApplied = false;
          this.styleloadingGrid = false;
        }
      }
    });
  },
  computed: {
    isV4CalculationEngine(): boolean {
      const engineType = String(this.calculationEngineType ?? "")
        .trim()
        .toLowerCase();
      return engineType === "gsdv4";
    },
    gridDataSource(): any {
      // Rows are already filtered by the API; serverFiltering stops Kendo from
      // re-filtering them in the browser with its own null/empty semantics.
      return { data: this.stylesData, serverFiltering: true };
    }
  },
  methods: {
    async getCalculationEngineType(): Promise<void> {
      const res = await this.userAdminSettingApi.apiSystemConfigurationGet();
      this.calculationEngineType = res.data.calculationEngineType?.defaultItem ?? "";
    },
    async ensureCalculationEngineType(): Promise<boolean> {
      if (this.calculationEngineType) {
        return true;
      }
      try {
        await this.getCalculationEngineType();
        return true;
      } catch {
        this.toast.error(this.error, { toastClassName: "custom-error-toast", timeout: 5000 });
        return false;
      }
    },
    async getFilteredData(filtersArray: any, sorting?: any, skip?: any, maxCount?: any) {
      this.styleloadingGrid = true;
      this.styleApi.apiGetFilteredStylesGet(JSON.stringify(filtersArray), sorting, skip, maxCount).then(res => {
        this.styleloadingGrid = false;
        let filteredStylesData: any[] = Object.assign([], res.data["items"]);
        for (let item of filteredStylesData) {
          if (typeof item.creationTime === "string") {
            item.creationTime = this.convertDate(item.creationTime);
          }
        }
        for (let item of this.allFilters) {
          for (let filter of item.filters) {
            if (filter.field == "creationTime" && filter.value != "" && filter.value != null) {
              filter.value = this.convertDate(filter.value);
            }
          }
        }
        this.updateGrid(filteredStylesData);
        this.currentPage = 1;
        this.$emit("updatePages", res.data.totalCount);
      });
    },
    convertDate(date: any) {
      const selectedDate = new Date(date);
      const shiftedUTC = new Date(
        Date.UTC(selectedDate.getFullYear(), selectedDate.getMonth(), selectedDate.getDate() - 1, 18, 30, 0)
      );
      return shiftedUTC;
    },
    async updateGrid(stylesData: any) {
      this.$nextTick(() => {
        const grid = (this.$refs["detailsGrid"] as any).kendoWidget();
        grid.dataSource.transport.data = stylesData;
        grid.dataSource.data(stylesData);
      });
    },
    downloadCsv: (function () {
      const a = document.createElement("a");
      document.body.appendChild(a);
      a.setAttribute("style", "display: none");
      return function (data: any, fileName: any) {
        const blob = new Blob([data], { type: "octet/stream" }),
          url = globalThis.URL.createObjectURL(blob);
        a.href = "data:text/csv;charset=utf-16,%EF%BB%BF" + encodeURIComponent(data);
        a.download = fileName;
        a.click();
        globalThis.URL.revokeObjectURL(url);
      };
    })(),
    onPaginationChange(event: BvEvent, page: number): void {
      if (this.isFilterApplied) {
        this.$emit("changeFilteredDataHandler", page, JSON.stringify(this.filtersArray));
      } else {
        this.$emit("changeDataHandler", page);
      }
    },
    async isOperationDataExist(styleId: number): Promise<boolean> {
      return await this.styleApi
        .apiSingleGarmentAndThreadUsageReportExistGet(styleId)
        .then(res => {
          return res.data;
        })
        .catch(e => {
          this.toast.error(e.errorMsg, {
            toastClassName: "custom-error-toast",
            timeout: 5000
          });
          return false;
        });
    },
    async singleGarmentReport(event: Event): Promise<void> {
      const target = event.target as any;
      let grid = (this.$refs["detailsGrid"] as any).kendoWidget();
      const row = target.closest("tr");
      const dataItemId = grid.dataItem(row).id;
      const reportExist: boolean = await this.isOperationDataExist(dataItemId);
      if (reportExist) {
        await this.reportApi
          .apiReportSingleGarmentIdGet(dataItemId, sessionStorage.getItem("lang") as unknown as string)
          .then(async e => {
            this.singleGarment = e.data;
            let fileName = "SingleGarmentReport.csv";
            this.downloadCsv(this.singleGarment, fileName);
            this.toast.success(this.success, {
              toastClassName: "custom-success-toast",
              timeout: 5000
            });
          })
          .catch(e => {
            this.toast.error(e.errorMsg, {
              toastClassName: "custom-error-toast",
              timeout: 5000
            });
          });
      } else {
        this.toast.error(this.incompleteData, {
          toastClassName: "custom-error-toast",
          timeout: 5000
        });
      }
      plausible.trackEvent("SGC-Report", { props: { TenantName: sessionStorage.getItem("TenantName") ?? "" } });
    },
    async downloadSingleGarmentReport(event: Event): Promise<void> {
      this.styleloadingGrid = true;
      const storedSelectedOption = localStorage.getItem("selectedReportPrintingOption");
      if (storedSelectedOption && storedSelectedOption == "csv") {
        await this.singleGarmentReport(event);
      } else {
        await this.singleGarmentPdf(event);
      }
      this.styleloadingGrid = false;
    },
    async downloadThreadGarmentReport(event: Event): Promise<void> {
      this.styleloadingGrid = true;
      const storedSelectedOption = localStorage.getItem("selectedReportPrintingOption");
      if (storedSelectedOption && storedSelectedOption == "csv") {
        await this.threadUsageReport(event);
      } else {
        await this.threadUsagePdf(event);
      }
      this.styleloadingGrid = false;
    },
    editStyle(event: Event): void {
      this.visible = true;
      const target = event.target as any;
      let grid = (this.$refs["detailsGrid"] as any).kendoWidget();
      const row = target.closest("tr");
      const dataItemId = grid.dataItem(row).id;
      sessionStorage.setItem("styleId", dataItemId);
      this.$emit("editStyleId", dataItemId);
    },
    duplicateStyle(event: Event): void {
      this.showPopup = true;
      const target = event.target as any;
      let grid = (this.$refs["detailsGrid"] as any).kendoWidget();
      const row = target.closest("tr");
      const dataItemId = grid.dataItem(row).id;
      this.duplicateStyleId = dataItemId;
    },
    visibleDialog(val: boolean): void {
      this.showPopup = val;
    },
    getDuplicateId(val: number): void {
      this.$emit("duplicateEditId", val);
    },
    async threadUsageReport(event: Event): Promise<void> {
      const target = event.target as any;
      let grid = (this.$refs["detailsGrid"] as any).kendoWidget();
      const row = target.closest("tr");
      const dataItemId = grid.dataItem(row).id;
      const reportExist: boolean = await this.isOperationDataExist(dataItemId);
      if (reportExist) {
        await this.reportApi
          .apiReportThreadUsageIdGet(dataItemId, sessionStorage.getItem("lang") as unknown as string)
          .then(async e => {
            this.threadUsage = e.data;
            let fileName = "ThreadUsageReport.csv";
            this.downloadCsv(this.threadUsage, fileName);
            this.toast.success(this.success, {
              toastClassName: "custom-success-toast",
              timeout: 5000
            });
          })
          .catch(e => {
            this.toast.error(e.errorMsg, {
              toastClassName: "custom-error-toast",
              timeout: 5000
            });
          });
      } else {
        this.toast.error(this.incompleteData, {
          toastClassName: "custom-error-toast",
          timeout: 5000
        });
      }
      plausible.trackEvent("SGC-Report", { props: { TenantName: sessionStorage.getItem("TenantName") ?? "" } });
    },
    async singleGarmentPdf(event: Event): Promise<void> {
      try {
        if (!(await this.ensureCalculationEngineType())) return;
        const target = event.target as any;
        const grid = (this.$refs["detailsGrid"] as any).kendoWidget();
        const row = target.closest("tr");
        const dataItemId = grid.dataItem(row).id;
        const reportExist: boolean = await this.isOperationDataExist(dataItemId);
        if (reportExist) {
          await this.reportApi
            .apiReportSingleGarmentPdfIdGet(dataItemId)
            .then(async res => {
              const doc = new jsPDF();
              this.lang = sessionStorage.getItem("lang");
              this.fontStyleForPDF = this.lang == "Chinese" ? "normal" : "bold";
              if (this.lang != undefined && this.lang != "English") {
                this.customFont = "CustomFont";
                doc.addFont(ArialUnicodeMS, "CustomFont", "normal");
              }
              this.generateStyleHeader(doc, res, true);
              this.generateThreadConsumptionSummary(doc, res);
              this.generateOperationSummary(doc, res);
              // The wastage note sits directly under the operation table and returns the Y that
              // "Last edited by" starts from; undefined leaves that block at its default position.
              const wastageNoteY = this.generateThreadWastageNote(doc, res, !this.isV4CalculationEngine);
              this.generateLastEditedBy(doc, res, wastageNoteY);
              this.generateFooter(doc, this.totalPages);
              doc.save(res.data.styleDetails?.name + "_SGC.pdf");
            })
            .catch(e => {
              this.toast.error(e.errorMsg, {
                toastClassName: "custom-error-toast",
                timeout: 5000
              });
            });
        } else {
          this.toast.error(this.incompleteData, {
            toastClassName: "custom-error-toast",
            timeout: 5000
          });
        }
        plausible.trackEvent("SGC-Report", { props: { TenantName: sessionStorage.getItem("TenantName") ?? "" } });
      } catch (error_) {
        console.log("exception", error_);
      }
    },
    async threadUsagePdf(event: Event): Promise<void> {
      if (!(await this.ensureCalculationEngineType())) return;
      const target = event.target as any;
      const grid = (this.$refs["detailsGrid"] as any).kendoWidget();
      const row = target.closest("tr");
      const dataItemId = grid.dataItem(row).id;
      const reportExist: boolean = await this.isOperationDataExist(dataItemId);
      if (reportExist) {
        await this.reportApi
          .apiReportThreadGarmentPdfIdGet(dataItemId)
          .then(async res => {
            const doc = new jsPDF();
            this.lang = sessionStorage.getItem("lang");
            this.fontStyleForPDF = this.lang == "Chinese" ? "normal" : "bold";
            if (this.lang != undefined && this.lang != "English") {
              this.customFont = "CustomFont";
              doc.addFont(ArialUnicodeMS, "CustomFont", "normal");
            }
            this.generateStyleHeader(doc, res, false);
            this.generateThreadRequirement(doc, res);
            this.generateOperationSummaryForThreadUsage(doc, res);
            this.generateTotalUnusedThread(doc, res);
            this.generateLastEditedBy(doc, res);
            this.generateFooter(doc, this.totalPages);
            doc.save(res.data.styleDetails?.name + "_TU.pdf");
          })
          .catch(e => {
            this.toast.error(e.errorMsg, {
              toastClassName: "custom-error-toast",
              timeout: 5000
            });
          });
      } else {
        this.toast.error(this.incompleteData, {
          toastClassName: "custom-error-toast",
          timeout: 5000
        });
      }
      plausible.trackEvent("SGC-Report", { props: { TenantName: sessionStorage.getItem("TenantName") ?? "" } });
    },
    generateStyleHeader(doc: any, res: any, isSingleGarmentReportPdf: boolean): void {
      const today = new Date();
      const formattedDate = today.toLocaleDateString("en-GB");
      this.pageWidth = doc.internal.pageSize.getWidth();
      const imageWidth = 50;
      const imageHeight = 8;
      const imageX = doc.internal.pageSize.getWidth() - imageWidth - 15;
      const imageY = 10;
      const maxImageWidth = doc.internal.pageSize.getWidth() - imageX - 10;
      const imageURL = "logo.png";
      doc.addImage(imageURL, "PNG", imageX + 3, imageY, Math.min(imageWidth, maxImageWidth) + 5, imageHeight);
      doc.setFontSize(12);
      if (this.lang == "English" || this.lang == "undefined" || this.lang == null) {
        doc.setFont("helvetica", "bold");
      } else {
        doc.setFont(this.customFont);
      }
      if (isSingleGarmentReportPdf) {
        doc.text(this.$t("styleGrid.singleGarmentReport"), 5, 18);
      } else {
        doc.text(this.$t("styleGrid.threadUsageReport"), 5, 18);
      }
      doc.setDrawColor(192, 192, 192);
      doc.setLineWidth(0.3);
      doc.line(5, 25, 205, 25);
      const styleHeaderData = [
        [
          { content: this.$t("styleGrid.style") + " :", styles: { fontStyle: this.fontStyleForPDF } },
          res.data.styleDetails?.name,
          { content: this.$t("styleGrid.customer") + " :", styles: { fontStyle: this.fontStyleForPDF } },
          res.data.styleDetails?.customer,
          { content: this.$t("styleGrid.createdBy") + " :", styles: { fontStyle: this.fontStyleForPDF } },
          res.data.styleDetails?.createdBy
        ],
        [
          { content: this.$t("styleGrid.productCategory") + " :", styles: { fontStyle: this.fontStyleForPDF } },
          res.data.styleDetails?.productCategory,
          { content: this.$t("styleGrid.product") + " :", styles: { fontStyle: this.fontStyleForPDF } },
          res.data.styleDetails?.productType,
          { content: this.$t("styleGrid.createdDate") + " :", styles: { fontStyle: this.fontStyleForPDF } },
          formattedDate
        ],
        [
          { content: this.$t("styleGrid.fabricWeight") + " :", styles: { fontStyle: this.fontStyleForPDF } },
          res.data.styleDetails?.weightType,
          { content: this.$t("styleGrid.color") + " :", styles: { fontStyle: this.fontStyleForPDF } },
          res.data.styleDetails?.color == "" ? "-" : res.data.styleDetails?.color,
          { content: this.$t("styleGrid.size") + " :", styles: { fontStyle: this.fontStyleForPDF } },
          res.data.styleDetails?.size == "" ? "-" : res.data.styleDetails?.size
        ],
        [
          { content: this.$t("styleGrid.description") + " :", styles: { fontStyle: this.fontStyleForPDF } },
          { content: res.data.styleDetails?.description == "" ? "-" : res.data.styleDetails?.description, colSpan: 5 }
        ]
      ];
      autoTable(doc, {
        body: styleHeaderData,
        headStyles: { font: "arial-unicode-ms-bold" },
        startY: 30,
        theme: "plain",
        styles: { overflow: "linebreak", font: this.customFont },
        margin: { left: 5, right: 5 }
      });
    },
    generateThreadConsumptionBody(res: any): any {
      let threadConsumptionSummaryData: any = [];
      for (let summary of res.data.threadConsumptionSummaries ?? []) {
        const rowData = [
          summary.brand,
          { content: summary.ticketTex, styles: { halign: "right" } },
          summary.shade == ""
            ? { content: "-", styles: { cellPadding: { left: 45, top: 2 } } }
            : { content: summary.shade, styles: { cellPadding: { left: 40, top: 2 } } },
          {
            content: summary.totalThreadConsumption.toFixed(2),
            styles: { halign: "right" }
          }
        ];
        threadConsumptionSummaryData.push(rowData);
      }
      return threadConsumptionSummaryData;
    },
    generateThreadConsumptionSummary(doc: any, res: any): void {
      let threadConsumptionSummaryData = this.generateThreadConsumptionBody(res);
      doc.line(5, doc.lastAutoTable?.finalY + 2, 205, doc.lastAutoTable?.finalY + 2);
      doc.text(this.$t("styleGrid.threadConsumptionSummary"), 5, doc.lastAutoTable?.finalY + 10);
      doc.setDrawColor(192, 192, 192);
      doc.setLineWidth(0.3);
      doc.line(5, doc.lastAutoTable?.finalY + 14, 205, doc.lastAutoTable?.finalY + 14);
      const unit = sessionStorage.getItem("seamLengthUnit") == "Metric" ? "(m)" : "(y)";
      let tktTex =
        res.data.styleDetails?.tktOrTex == "Tex" ? this.$t("operationCreateComp.tex") : this.$t("styleGrid.ticket");
      const header = [
        [this.$t("styleGrid.brand"), tktTex, this.$t("styleGrid.shade"), this.$t("styleGrid.totalThread") + unit]
      ];
      const totalRow = [
        this.$t("styleGrid.total"),
        "",
        "",
        { content: res.data.totalConsumption as number, styles: { halign: "right" } }
      ];
      threadConsumptionSummaryData.push(totalRow);
      autoTable(doc, {
        head: header,
        headStyles: { textColor: "black", fillColor: "white", font: "arial-unicode-ms-bold" },
        body: threadConsumptionSummaryData,
        theme: "plain",
        margin: { left: 5, right: 5 },
        styles: { overflow: "linebreak", font: this.customFont },
        columnStyles: {
          1: { cellWidth: this.pageWidth / 5 }
        },
        startY: doc.lastAutoTable?.finalY + 16,
        didParseCell: data => {
          if (data.section == "head" && data.row.section == "head") {
            if (data.column.index == 3 || data.column.index == 1) {
              const { styles } = data.cell;
              styles.halign = "right";
            }
            if (data.column.index == 2) {
              const { styles } = data.cell;
              styles.cellPadding = { left: 40, top: 2 };
            }
          }
          if (data.section === "body" && data.row.section === "body") {
            if (data.row.index === threadConsumptionSummaryData.length - 1) {
              const { styles } = data.cell;
              styles.font = "arial-unicode-ms-bold";
              styles.fontStyle = "bold";
            }
            if (data.row.index >= 0 && data.row.index != threadConsumptionSummaryData.length - 1) {
              data.cell.styles.textColor = "#58595B";
            }
          }
        },
        didDrawCell: data => {
          if (data.section === "head") {
            doc.setDrawColor(192, 192, 192);
            doc.setLineWidth(0.3);
            doc.line(
              data.cell.x,
              data.cell.y + data.cell.height,
              data.cell.x + data.cell.width,
              data.cell.y + data.cell.height
            );
          }
          if (data.section === "body" && data.row.section === "body") {
            const { doc, cell } = data;
            doc.setDrawColor(192, 192, 192);
            doc.setLineWidth(0.3);
            doc.line(cell.x, cell.y + cell.height, cell.x + cell.width, cell.y + cell.height);
          }
        },
        didDrawPage: () => {
          this.currentPage = doc.internal.getNumberOfPages();
          this.totalPages = this.currentPage;
        }
      });
    },
    generateTotalUnusedThreadBody(res: any): any {
      let totalUnusedThread: any[] = [];
      for (let summary of res.data.totalUnusedThread.unusedThreadItems ?? []) {
        const rowData = [
          summary.article,
          summary.brand,
          {
            content: summary.ticketTex,
            styles: { halign: "right", cellPadding: { right: 20, top: 2 } }
          },
          summary.shade == "" ? { content: "-", styles: { cellPadding: { left: 5, top: 2 } } } : summary.shade,
          { content: summary.threadConsumption.toFixed(2), styles: { halign: "right" } }
        ];
        totalUnusedThread.push(rowData);
      }
      return totalUnusedThread;
    },
    generateTotalUnusedThread(doc: any, res: any): void {
      let totalUnusedThread = this.generateTotalUnusedThreadBody(res);
      doc.setFont(this.customFont);
      doc.setFontSize(12);
      doc.setFont(this.customFont);
      doc.setDrawColor(192, 192, 192);
      doc.setLineWidth(0.3);
      const lenthUnit = sessionStorage.getItem("packageUnitVal") == "Metric" ? "(m)" : "(y)";
      const totalUnusedThreadVal = this.$t("styleGrid.totalUnusedThread");
      let tktTex =
        res.data.styleDetails?.tktOrTex == "Tex" ? this.$t("operationCreateComp.tex") : this.$t("styleGrid.ticket");
      const header = [
        [{ content: totalUnusedThreadVal + "", colSpan: 5 }],
        [
          this.$t("styleGrid.article"),
          this.$t("styleGrid.brand"),
          tktTex,
          this.$t("styleGrid.shade"),
          this.$t("styleGrid.length") + " " + lenthUnit
        ]
      ];
      const partPackages = [
        this.$t("styleGrid.partPackages"),
        "",
        "",
        "",
        { content: res.data.totalUnusedThread?.partPackages.toFixed(2), styles: { halign: "right" } }
      ];
      const extraPackages = [
        this.$t("styleGrid.extraPackages"),
        "",
        "",
        "",
        { content: res.data.totalUnusedThread?.extraPackages.toFixed(2), styles: { halign: "right" } }
      ];
      const totalUnusedThreadMetric = [
        { content: totalUnusedThreadVal + " " + lenthUnit, colSpan: 4 },
        { content: res.data.totalUnusedThread?.totalUnuseThread.toFixed(2), styles: { halign: "right" } }
      ];
      totalUnusedThread.push(partPackages, extraPackages, totalUnusedThreadMetric);
      autoTable(doc, {
        head: header,
        headStyles: { fillColor: "white", textColor: "black", font: "arial-unicode-ms-bold" },
        body: totalUnusedThread,
        theme: "plain",
        margin: { left: 5, right: 5 },
        styles: { font: this.customFont },
        startY: doc.lastAutoTable?.finalY + 2,
        didDrawCell: data => {
          if (data.section === "head") {
            doc.setDrawColor(192, 192, 192);
            doc.setLineWidth(0.3);
            doc.line(
              data.cell.x,
              data.cell.y + data.cell.height,
              data.cell.x + data.cell.width,
              data.cell.y + data.cell.height
            );
          }
          if (data.section === "body" && data.row.section === "body") {
            const { doc, cell } = data;
            doc.setDrawColor(192, 192, 192);
            doc.setLineWidth(0.3);
            doc.line(cell.x, cell.y + cell.height, cell.x + cell.width, cell.y + cell.height);
          }
        },
        didDrawPage: () => {
          this.currentPage = doc.internal.getNumberOfPages();
          this.totalPages = this.currentPage;
        },
        didParseCell: data => {
          if (data.section == "head" && data.row.section == "head") {
            this.styleHeadCell(data);
          }
          if (data.section === "body" && data.row.section === "body") {
            if (data.row.index >= totalUnusedThread.length - 3) {
              const { styles } = data.cell;
              styles.fontStyle = this.fontStyleForPDF;
              data.cell.styles.textColor = "black";
            }
            if (
              data.row.index >= 0 &&
              data.row.index != totalUnusedThread.length - 3 &&
              data.row.index != totalUnusedThread.length - 2 &&
              data.row.index != totalUnusedThread.length - 1
            ) {
              data.cell.styles.textColor = "#58595B";
            }
          }
        }
      });
    },
    styleHeadCell(data: any) {
      const { styles } = data.cell;
      if (data.column.index == 4) {
        styles.halign = "right";
      }
      if (data.column.index == 2) {
        styles.cellPadding = { right: 20, top: 2 };
        styles.halign = "right";
      }
      if (data.column.index == 0 && data.row.index == 0) {
        styles.fontSize = 12;
      }
    },
    generateThreadRequirement(doc: any, res: any): void {
      let threadRequirement: any[][] = [];
      for (let summary of res.data.threaRequirementDetails ?? []) {
        const rowData = [
          summary.brand,
          { content: summary.article, styles: { halign: "right" } },
          { content: summary.ticketTex, styles: { halign: "right" } },
          summary.shade == "" ? { content: "-", styles: { halign: "center" } } : summary.shade,
          { content: summary.quantity, styles: { halign: "right" } },
          summary.unit,
          { content: summary.price.toFixed(2), styles: { halign: "right" } },
          {
            content: summary.cost.toFixed(2) as unknown as string,
            styles: { halign: "right" }
          }
        ];
        threadRequirement.push(rowData);
      }
      doc.setFont(this.customFont);
      doc.setFontSize(12);
      doc.line(5, doc.lastAutoTable?.finalY + 2, 205, doc.lastAutoTable?.finalY + 2);
      doc.text(this.$t("styleGrid.threadRequirement"), 5, doc.lastAutoTable?.finalY + 10);
      let boldTextWidth = doc.getTextWidth(this.$t("styleGrid.threadRequirement"));
      let threadRequirementHeaderTxt = ((((res.data.styleDetails?.quantity as unknown as string) +
        this.$t("styleGrid.garments")) as unknown as string) +
        res.data.styleDetails?.noOfProductionLines +
        this.$t("styleGrid.team")) as unknown as string;
      doc.text(threadRequirementHeaderTxt, 5 + boldTextWidth, doc.lastAutoTable?.finalY + 10);
      let allowanceHeaderTxt = this.$t("styleGrid.allowance") + " % :";
      boldTextWidth = doc.getTextWidth(allowanceHeaderTxt);
      doc.text(allowanceHeaderTxt, 195 - boldTextWidth, doc.lastAutoTable?.finalY + 10);
      doc.text(" " + res.data.styleDetails?.allowance, 195, doc.lastAutoTable?.finalY + 10);
      doc.setDrawColor(192, 192, 192);
      doc.setLineWidth(0.3);
      doc.line(5, doc.lastAutoTable?.finalY + 15, 205, doc.lastAutoTable?.finalY + 15);
      let tktTex =
        res.data.styleDetails?.tktOrTex == "Tex"
          ? this.$t("operationCreateComp.tex")
          : this.$t("operationCreateComp.tkt");
      const header = [
        [
          this.$t("styleGrid.brand"),
          this.$t("styleGrid.article"),
          tktTex,
          this.$t("styleGrid.shade"),
          this.$t("styleGrid.quantity"),
          this.$t("styleGrid.unit"),
          this.$t("styleGrid.price"),
          this.$t("styleGrid.cost") + " (" + res.data.currencyUnit + ")"
        ]
      ];
      const totalCost = [
        { content: this.$t("styleGrid.total"), styles: { fontStyle: "bold" }, colSpan: 7 },
        { content: res.data.totalThreadCost.toFixed(2), styles: { halign: "right" } }
      ];
      const avgCost = [
        { content: this.$t("styleGrid.avgCostOfThreadPerGarment"), styles: { fontStyle: "bold" }, colSpan: 7 },
        { content: res.data.averageThreadCost.toFixed(2), styles: { halign: "right" } }
      ];
      threadRequirement.push(totalCost, avgCost);
      autoTable(doc, {
        head: header,
        headStyles: { fillColor: "white", textColor: "black", font: "arial-unicode-ms-bold" },
        body: threadRequirement,
        theme: "plain",
        margin: { left: 5, right: 5 },
        startY: doc.lastAutoTable?.finalY + 20,
        styles: { font: this.customFont },
        didParseCell: data => {
          if (data.section == "head" && data.row.section == "head") {
            if (
              data.column.index == 1 ||
              data.column.index == 2 ||
              data.column.index == 4 ||
              data.column.index == 6 ||
              data.column.index == 7
            ) {
              const { styles } = data.cell;
              styles.halign = "right";
            }
          }
          if (data.section === "body" && data.row.section === "body") {
            if (data.row.index >= threadRequirement.length - 2) {
              const { styles } = data.cell;

              styles.font = "arial-unicode-ms-bold";
              styles.fontStyle = "bold";
              data.cell.styles.textColor = "black";
            }
            if (
              data.row.index >= 0 &&
              data.row.index != threadRequirement.length - 2 &&
              data.row.index != threadRequirement.length - 1
            ) {
              data.cell.styles.textColor = "#58595B";
            }
          }
        },
        didDrawCell: data => {
          if (data.section === "head") {
            doc.setDrawColor(192, 192, 192);
            doc.setLineWidth(0.3);
            doc.line(
              data.cell.x,
              data.cell.y + data.cell.height,
              data.cell.x + data.cell.width,
              data.cell.y + data.cell.height
            );
          }
          if (data.section === "body" && data.row.section === "body") {
            const { doc, cell } = data;
            doc.setDrawColor(192, 192, 192);
            doc.setLineWidth(0.3);
            doc.line(cell.x, cell.y + cell.height, cell.x + cell.width, cell.y + cell.height);
          }
        },
        didDrawPage: () => {
          this.currentPage = doc.internal.getNumberOfPages();
          this.totalPages = this.currentPage;
        }
      });
    },
    // Draws the note asked for by reports whose thread figures already include wastage (the Seamworks
    // engine ones), directly under the operation table and above every other note. Returns the Y the
    // next block starts from, or undefined when nothing was drawn so callers keep their own defaults.
    generateThreadWastageNote(doc: any, res: any, show: boolean): number | undefined {
      if (!show) return undefined;
      let y = doc.lastAutoTable?.finalY + 14;
      if (res.data.isTensionSettingsChanged) y += 8;
      // Restored afterwards so the italic 10pt does not leak into the notes drawn below this one.
      const previousFont = doc.getFont();
      const previousFontSize = doc.getFontSize();
      // Only helvetica has italic letterforms. The bundled Unicode font has none, and jsPDF would
      // silently swap in Times-Italic, which cannot draw the non-Latin scripts.
      doc.setFont(this.customFont, this.customFont == "helvetica" ? "italic" : "normal");
      doc.setFontSize(10);
      doc.text(this.$t("styleGrid.threadWastageNote"), 5, y);
      doc.setFont(previousFont.fontName, previousFont.fontStyle);
      doc.setFontSize(previousFontSize);
      // 8mm is what the existing code already allows per note line under the table.
      return y + 8;
    },
    generateFooter(doc: jsPDF, totalPages: number): void {
      doc.setFont("helvetica", "normal");
      const currentDate = new Date();
      const options: any = {
        year: "numeric",
        month: "long",
        day: "numeric",
        hour: "numeric",
        minute: "2-digit",
        second: "2-digit",
        hour12: true
      };
      const printedDate = "Date Printed: " + currentDate.toLocaleString("en-US", options);
      for (let i = 1; i <= totalPages; i++) {
        doc.setPage(i);
        const footerX = doc.internal.pageSize.getWidth() / 2;
        const footerY = doc.internal.pageSize.getHeight() - 10;
        doc.setFontSize(10);
        doc.text(`Page ${i} of ${totalPages}`, footerX, footerY, { align: "center" });
        doc.text(printedDate, doc.internal.pageSize.getWidth() - 10, footerY, { align: "right" });
      }
    },
    // Renders "Last edited By" + edited date/time in the report body, left-aligned. Defaults to just
    // below the last content table; pass startY to place it below other content drawn after the table
    // (e.g. the SGC quantity note) so the blocks don't overlap.
    generateLastEditedBy(doc: any, res: any, startY?: number): void {
      const lastEditedBy = res?.data?.styleDetails?.editedBy;
      const editedDate = res?.data?.styleDetails?.editedDate;
      let y = startY ?? doc.lastAutoTable?.finalY + 14;
      if (startY === undefined && res.data.isTensionSettingsChanged) y += 8;
      // Page footer is drawn at pageHeight - 10; if the two text lines (y and y + 5) would
      // enter that reserved strip, move the block to a fresh page and count it for the footer.
      const footerReserveY = doc.internal.pageSize.getHeight() - 15;
      if (y + 5 > footerReserveY) {
        doc.addPage();
        this.currentPage = doc.internal.getNumberOfPages();
        this.totalPages = this.currentPage;
        y = 15;
      }
      doc.setFont("helvetica", "normal");
      doc.setFontSize(10);
      const lastEditedByLabel = (this.$t("styleGrid.lastEditedBy") as unknown as string) + ":";
      doc.text(lastEditedByLabel, 5, y);
      const valueX = 5 + doc.getTextWidth(lastEditedByLabel) + 3;
      doc.text(lastEditedBy ?? "", valueX, y);
      doc.text(editedDate ?? "", valueX, y + 5);
    },
    createRowForOperationSummaryBody(summary: any, index: any, styleOp: any) {
      if (index != 0) {
        return [
          "",
          "",
          "",
          "",
          ...(this.isV4CalculationEngine ? ["", ""] : []),
          styleOp.needleName,
          styleOp.brand,
          { content: styleOp.ticketTex, styles: { halign: "center" } },
          styleOp.shade == "" ? { content: "-", styles: { halign: "center" } } : styleOp.shade,
          { content: styleOp.threadConsumption, styles: { halign: "center" } }
        ];
      }
      const operation = summary.description;
      return [
        { content: operation, rowSpan: summary.styleOperations.length },
        summary.bight === 0
          ? { content: "-", styles: { halign: "right", cellPadding: { right: 6, top: 2 } } }
          : { content: summary.bight.toFixed(2), styles: { halign: "right" } },
        { content: summary.seamLength, styles: { halign: "right" } },
        summary.rate === 0
          ? { content: "-", styles: { halign: "center" } }
          : { content: summary.rate, styles: { halign: "right" } },
        summary.stitchTypeCode,
        ...(this.isV4CalculationEngine
          ? [
              { content: summary.wastagePerSeam ?? "-", styles: { halign: "right" } },
              summary.needleDistance === 0 || summary.needleDistance == null
                ? { content: "-", styles: { halign: "center" } }
                : { content: summary.needleDistance, styles: { halign: "right" } }
            ]
          : []),
        styleOp.needleName,
        styleOp.brand,
        { content: styleOp.ticketTex, styles: { halign: "center" } },
        styleOp.shade == "" ? { content: "-", styles: { halign: "center" } } : styleOp.shade,
        { content: styleOp.threadConsumption, styles: { halign: "center" } }
      ];
    },
    generateOperationSummaryBody(res: any): any {
      let operationSummaryData: any[][] = [];
      for (let summary of res.data.operationSummary ?? []) {
        for (let [index, styleOp] of summary.styleOperations.entries()) {
          let rowData = this.createRowForOperationSummaryBody(summary, index, styleOp);
          operationSummaryData.push(rowData);
        }
      }
      operationSummaryData = operationSummaryData
        .map(subArray => subArray.filter(element => element !== undefined))
        .filter(subArray => subArray.length > 0);
      return operationSummaryData;
    },

    generateOperationSummary(doc: any, res: any): void {
      let operationSummaryData = this.generateOperationSummaryBody(res);
      doc.text(this.$t("styleGrid.operationSummary"), 5, doc.lastAutoTable?.finalY + 8);
      doc.setDrawColor(192, 192, 192);
      doc.setLineWidth(0.3);
      doc.line(5, doc.lastAutoTable?.finalY + 13, 205, doc.lastAutoTable?.finalY + 13);
      let tktTex =
        res.data.styleDetails?.tktOrTex == "Tex"
          ? this.$t("operationCreateComp.tex")
          : this.$t("operationCreateComp.tkt");
      const isMetric = sessionStorage.getItem("seamLengthUnit") == "Metric";
      const lengthUnit = isMetric ? " (cm)" : " (in)";
      const lengthLabel = isMetric ? this.$t("styleGrid.length") + " (cm)" : this.$t("styleGrid.length") + " (in)";

      const header = [
        [
          this.$t("styleGrid.operation"),
          sessionStorage.getItem("seamLengthUnit") == "Metric"
            ? this.$t("styleGrid.bight") + " (mm)"
            : this.$t("styleGrid.bight") + " (in)",
          this.isV4CalculationEngine
            ? this.$t("operationListComp.seamLength") + lengthUnit + " / " + this.$t("editComponent.stitchCount")
            : lengthLabel,
          sessionStorage.getItem("seamLengthUnit") == "Metric" ? "SP /3cm" : "SP /in",
          this.$t("styleGrid.stitch"),
          ...(this.isV4CalculationEngine
            ? [
                sessionStorage.getItem("seamLengthUnit") == "Metric"
                  ? this.$t("editComponent.wastagePerSeam") + " (cm)"
                  : this.$t("editComponent.wastagePerSeam") + " (in)",
                this.$t("editComponent.needleDistance")
              ]
            : []),
          this.$t("styleGrid.component"),
          this.$t("styleGrid.brand"),
          tktTex,
          this.$t("styleGrid.shade"),
          sessionStorage.getItem("seamLengthUnit") == "Metric"
            ? this.$t("styleGrid.thread") + " (cm)"
            : this.$t("styleGrid.thread") + " (in)"
        ]
      ];
      autoTable(doc, {
        head: header,
        headStyles: { textColor: "black", fillColor: "white", font: "arial-unicode-ms-bold" },
        theme: "plain",
        body: operationSummaryData,
        startY: doc.lastAutoTable?.finalY + 16,
        styles: { overflow: "linebreak", font: this.customFont },
        columnStyles: {
          0: { cellWidth: this.pageWidth / 7 }
        },
        margin: { left: 5, right: 5 },
        didParseCell: data => {
          if (data.section === "body" && data.cell.section === "body") {
            data.cell.styles.textColor = "#58595B";
          }
          if (data.section == "head" && data.row.section == "head") {
            const rightAlignedHeaderCols = this.isV4CalculationEngine ? [1, 2, 3, 5, 6] : [1, 2, 3];
            if (rightAlignedHeaderCols.includes(data.column.index)) {
              const { styles } = data.cell;
              styles.halign = "right";
            }
          }
        },
        didDrawCell: data => {
          if (data.section === "head") {
            doc.setDrawColor(192, 192, 192);
            doc.setLineWidth(0.3);
            doc.line(
              data.cell.x,
              data.cell.y + data.cell.height,
              data.cell.x + data.cell.width,
              data.cell.y + data.cell.height
            );
          }
          if (data.section === "body" && data.row.section === "body") {
            if (data.column.index == 0) {
              const { doc, cell } = data;
              doc.setDrawColor(192, 192, 192);
              doc.setLineWidth(0.3);
              doc.line(cell.x, cell.y + cell.height, 205, cell.y + cell.height);
            }
          }
        },
        didDrawPage: () => {
          this.currentPage = doc.internal.getNumberOfPages();
          this.totalPages = this.currentPage;
        }
      });
      if (res.data.isTensionSettingsChanged) {
        doc.setFont(this.customFont, "bold");
        doc.setFontSize(12);
        doc.text("* -  " + this.$t("styleGrid.tensionSettingOfStitchTypeChanged"), 5, doc.lastAutoTable?.finalY + 12);
      }
    },
    createRowForOperationSummaryForThreadUsage(summary: any, index: any, styleOp: any) {
      if (index === 0) {
        const rowData: any[] = [
          { content: summary.description, rowSpan: summary.styleOperations.length },
          { content: summary.stitchTypeCode, styles: { halign: "right" } },
          { content: summary.machines, styles: { halign: "right" } },
          ...(this.isV4CalculationEngine
            ? [
                { content: summary.wastagePerSeam ?? "-", styles: { halign: "right" } },
                summary.needleDistance === 0 || summary.needleDistance == null
                  ? { content: "-", styles: { halign: "center" } }
                  : { content: summary.needleDistance, styles: { halign: "right" } }
              ]
            : []),
          summary.styleOperations?.[0].needleName,
          summary.styleOperations?.[0].brand,
          { content: summary.styleOperations?.[0].threadQuantity, styles: { halign: "right" } },
          { content: summary.styleOperations?.[0].article, styles: { halign: "right" } },
          summary.styleOperations?.[0].ticketTex,
          summary.styleOperations?.[0].shade == ""
            ? { content: "-", styles: { halign: "center" } }
            : summary.styleOperations?.[0].shade
        ];
        return rowData;
      } else {
        const rowData1: any[] = [
          "",
          "",
          ...(this.isV4CalculationEngine ? ["", ""] : []),
          styleOp.needleName,
          styleOp.brand,
          { content: styleOp.threadQuantity, styles: { halign: "right" } },
          { content: styleOp.article, styles: { halign: "right" } },
          styleOp.ticketTex,
          styleOp.shade == "" ? { content: "-", styles: { halign: "center" } } : styleOp.shade
        ];
        return rowData1;
      }
    },
    generateOperationSummaryForThreadUsage(doc: any, res: any): void {
      let operationSummaryData: any[][] = [];
      for (let summary of res.data.operationSummary ?? []) {
        for (let [index, styleOp] of summary.styleOperations.entries()) {
          let rowData = this.createRowForOperationSummaryForThreadUsage(summary, index, styleOp);
          operationSummaryData.push(rowData.slice());
        }
      }
      operationSummaryData = operationSummaryData
        .map(subArray => subArray.filter(element => element !== undefined))
        .filter(subArray => subArray.length > 0);
      doc.text(this.$t("styleGrid.operationSummary"), 5, doc.lastAutoTable?.finalY + 8);
      doc.setDrawColor(192, 192, 192);
      doc.setLineWidth(0.3);
      doc.line(5, doc.lastAutoTable?.finalY + 12, 205, doc.lastAutoTable?.finalY + 12);
      let tktTex =
        res.data.styleDetails?.tktOrTex == "Tex"
          ? this.$t("operationCreateComp.tex")
          : this.$t("operationCreateComp.tkt");
      const header = [
        [
          this.$t("styleGrid.operation"),
          this.$t("styleGrid.stitch"),
          this.$t("styleGrid.machines"),
          ...(this.isV4CalculationEngine
            ? [
                sessionStorage.getItem("seamLengthUnit") == "Metric"
                  ? this.$t("editComponent.wastagePerSeam") + " (cm)"
                  : this.$t("editComponent.wastagePerSeam") + " (in)",
                this.$t("editComponent.needleDistance")
              ]
            : []),
          this.$t("styleGrid.component"),
          this.$t("styleGrid.brand"),
          this.$t("styleGrid.quantity"),
          this.$t("styleGrid.article"),
          tktTex,
          this.$t("styleGrid.shade")
        ]
      ];
      autoTable(doc, {
        head: header,
        headStyles: { fillColor: "white", textColor: "black", font: "arial-unicode-ms-bold" },
        theme: "plain",
        body: operationSummaryData,
        startY: doc.lastAutoTable?.finalY + 15,
        margin: { left: 5, right: 5 },
        styles: { font: this.customFont },
        columnStyles: {
          0: { cellWidth: this.pageWidth / 7 }
        },
        didParseCell: data => {
          if (data.section == "head" && data.row.section == "head") {
            const rightAlignedHeaderCols = this.isV4CalculationEngine ? [1, 2, 3, 4, 7, 8] : [1, 2, 5, 6];
            if (rightAlignedHeaderCols.includes(data.column.index)) {
              const { styles } = data.cell;
              styles.halign = "right";
            }
          }
          if (data.section === "body" && data.cell.section === "body") {
            data.cell.styles.textColor = [112, 112, 112];
          }
        },
        didDrawCell: data => {
          if (data.section === "head") {
            doc.setDrawColor(192, 192, 192);
            doc.setLineWidth(0.3);
            doc.line(
              data.cell.x,
              data.cell.y + data.cell.height,
              data.cell.x + data.cell.width,
              data.cell.y + data.cell.height
            );
          }
          if (data.section === "body" && data.row.section === "body") {
            if (data.column.index == 0) {
              const { doc, cell } = data;
              doc.setDrawColor(192, 192, 192);
              doc.setLineWidth(0.3);
              doc.line(cell.x, cell.y + cell.height, 205, cell.y + cell.height);
            }
          }
        },
        didDrawPage: () => {
          this.currentPage = doc.internal.getNumberOfPages();
          this.totalPages = this.currentPage;
        }
      });
    },
    async deleteStyle(event: Event): Promise<void> {
      const target = event.target as any;
      let grid = (this.$refs["detailsGrid"] as any).kendoWidget();
      const row = target.closest("tr");
      const dataItemId = grid.dataItem(row).id;
      let modalcontent = this.areYouSureYouWantToDeleteStyle + " " + grid.dataItem(row).name + " ?";
      try {
        const value: boolean | null = await this.confirmModal(this.confrim, modalcontent);
        if (value) {
          try {
            await this.styleApi.apiStyleDeleteIdDelete(dataItemId);
            this.toast.success(this.success + " : " + this.deletedTitle, {
              toastClassName: "custom-success-toast",
              timeout: 5000
            });
            location.reload();
          } catch (e: any) {
            this.toast.error(e.errorMsg, {
              toastClassName: "custom-error-toast",
              timeout: 5000
            });
          }
        }
      } catch (err: any) {
        this.toast.error(err.errorMsg, {
          toastClassName: "custom-error-toast",
          timeout: 5000
        });
      }
    },
    async gettingAdminData(): Promise<void> {
      await this.userAdminSettingApi.apiUserAdminSettingGet().then(async res => {
        for (let adminData of res.data.items ?? []) {
          if (adminData.field == "TktTex") {
            this.tktTexValue = adminData.value as any;
          } else if (adminData.field == "SeamLengthUnit") {
            this.seamLengthUnit = adminData.value as any;
          } else if (adminData.field == "DefaultAllowance") {
            this.defaultAllowanceVal = adminData.value as any;
          }
        }
        this.ConfigurationString = (this.$t("dialogBox.dataUpload") +
          "    (" +
          this.$t("dialogBox.lengthMeasurementUnit") +
          " : " +
          this.seamLengthUnit +
          ")" +
          " (" +
          this.$t("dialogBox.allowance") +
          " : " +
          this.defaultAllowanceVal +
          ")" +
          " (" +
          this.tktTexValue +
          ")") as string;
      });
    }
  }
});
</script>
<style scoped>
.style-grid-container {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.grid-wrapper {
  flex: 1;
  overflow: hidden;
}

.pagination-footer {
  position: sticky;
  bottom: 0;
  background: white;
  border-top: 1px solid #ddd;
  padding: 1rem 0;
  z-index: 1000;
  box-shadow: 0 -2px 4px rgba(0, 0, 0, 0.1);
}

.b-toaster {
  z-index: 999999 !important;
}

.app-config-loader {
  background-color: #fff;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 99999;
}

.loading-text {
  position: absolute;
  top: calc(50% + 50px);
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>
